import styled from '@emotion/styled';
import { RacemapColors } from '@racemap/utilities/consts/common';
import type { FC } from 'react';
import { useInspectedTracker } from '../../../lib/customHooks';
import { MiniMap } from '../../BasicComponents/Maps';
import { PointLayer } from '../../BasicComponents/Maps/Layers';
import { dresdenViewport } from '../../BasicComponents/Maps/mocks';

export const LocationTab: FC = () => {
  const inspectedTracker = useInspectedTracker();
  const lastGeo = inspectedTracker?.lastGeo;
  const point = lastGeo?.lng != null && lastGeo?.lat != null ? [lastGeo.lng, lastGeo.lat] : null;
  const windowHeight = window.innerHeight;

  return (
    <Container windowHeight={windowHeight}>
      <MiniMap
        defaultViewState={dresdenViewport}
        controls={{ navigation: true, fitToViewport: true }}
      >
        <PointLayer
          autofocus
          points={point}
          color={RacemapColors.PaleBlue}
          radius={5}
          lineWidth={3}
          fillColor="white"
        />
      </MiniMap>
    </Container>
  );
};

const Container = styled.div<{ windowHeight: number }>`
  height: ${({ windowHeight }) => windowHeight * 0.5}px;
  .nav-item,
  .nav {
    border-color: darkgray;
  }

  .nav-link {
    padding: 0.2rem 0.5rem;
  }
`;
